import React, { useState, useRef, useEffect } from 'react';
import './App.css';
import ChatMessage from './components/ChatMessage';
import TypingIndicator from './components/TypingIndicator';
import ChatInput from './components/ChatInput';
import Sidebar from './components/Sidebar';
import Header from './components/Header';

function App() {
  const [input, setInput] = useState('');
  const [chatHistory, setChatHistory] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const messagesEndRef = useRef(null);
  const { REACT_APP_API_URL } = process.env;

  // Scroll automático para o final ao adicionar mensagens
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  useEffect(() => {
    scrollToBottom();
  }, [chatHistory]);

  // Enviar mensagem
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!input.trim()) return;

    const now = new Date();
    const timestamp = now.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    const userMessage = { role: 'user', content: input, timestamp };

    const updatedHistory = [...chatHistory, userMessage];
    setChatHistory(updatedHistory);
    setInput('');
    setIsLoading(true);

    const responseTimestamp = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

    try {
      const response = await fetch(`${REACT_APP_API_URL}/chat`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          message: input,
          history: updatedHistory
        }),
      });

      const data = await response.json();

      if (response.ok && data.response) {
        setChatHistory(prev => [...prev, {
          role: 'assistant',
          content: data.response,
          timestamp: responseTimestamp
        }]);
      } else {
        setChatHistory(prev => [...prev, {
          role: 'assistant',
          content: `Erro: ${data.error || 'Não foi possível processar sua requisição.'}`,
          timestamp: responseTimestamp
        }]);
      }

    } catch (error) {
      setChatHistory(prev => [...prev, {
        role: 'assistant',
        content: `Erro de conexão: ${error.message}`,
        timestamp: responseTimestamp
      }]);
    } finally {
      setIsLoading(false);
    }
  };

  // Nova conversa
  const startNewChat = () => {
    setChatHistory([]);
    setIsSidebarOpen(false);
  };

  return (
    <div className="app">
      {/* Botão de menu mobile */}
      <button 
        className="menu-button" 
        onClick={() => setIsSidebarOpen(!isSidebarOpen)}
        style={{ display: window.innerWidth <= 768 ? 'block' : 'none' }}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <line x1="3" y1="12" x2="21" y2="12"></line>
          <line x1="3" y1="6" x2="21" y2="6"></line>
          <line x1="3" y1="18" x2="21" y2="18"></line>
        </svg>
        <span className="sr-only">Menu</span>
      </button>

      {/* Sidebar */}
      <Sidebar isSidebarOpen={isSidebarOpen} startNewChat={startNewChat} />

      {/* Conteúdo principal */}
      <main className="main-content">
        <Header />

        <div className="chat-container">
          <div className="messages">
            {/* Mensagem de boas-vindas */}
            <ChatMessage
              role="assistant"
              content={`# Bem-vindo ao Java Dev Assistant! 👋

Estou aqui para ajudar com todas as suas dúvidas de desenvolvimento Java. Posso auxiliar com:

- Debugging de código
- Explicação de conceitos Java
- Exemplos de implementação
- Design patterns
- Frameworks como Spring, Hibernate, etc.
- Performance e otimização

Como posso ajudar você hoje?`}
            />

            {/* Histórico de mensagens */}
            {chatHistory.map((message, index) => (
              <ChatMessage
                key={index}
                role={message.role}
                content={message.content}
                timestamp={message.timestamp}
              />
            ))}

            {/* Indicador de carregamento */}
            {isLoading && <TypingIndicator />}

            <div ref={messagesEndRef} />
          </div>
        </div>

        {/* Input */}
        <ChatInput
          input={input}
          setInput={setInput}
          handleSubmit={handleSubmit}
          isLoading={isLoading}
        />
      </main>
    </div>
  );
}

export default App;
